import { HazardBaseLayer } from "./HazardBaseLayer";

interface Props {
  defaultVisible: boolean;
  visible?: boolean;
}

const host = process.env.VITE_HAZARD_TILE_HOST ?? "";
const url = `${host}/49/storm_surge_49.pmtiles`;

export const STORM_SURGE_LAYER_NAME = "高潮浸水想定（最大浸水深クラス）";

// A49_003_CLASS のクラス別色
const colorMap: Record<string, string> = {
  "~0.3m": "#FFFFB3",
  "~0.5m": "#F7F5A9",
  "0.5-1m": "#F8E1A6",
  "0.5-3m": "#FFD8C0",
  "3-5m": "#FFB7B7",
  "5-10m": "#FF9191",
  "10-20m": "#F285C9",
  "20m~": "#DC7ABC",
};

const attributeKey = "A49_003_CLASS";
const dataLayer = "a49";
const minzoom = 14;
const maxzoom = 22;

/*
高潮浸水想定（最大浸水深クラス）レイヤー
タイル元データ: tmp/a49/a49_class.pmtiles（A49 をクラス化）
*/
export const HazardStormSurgeLayer: React.FC<Props> = ({
  defaultVisible,
  visible,
}) => {
  return (
    <HazardBaseLayer
      defaultVisible={defaultVisible}
      layerName={STORM_SURGE_LAYER_NAME}
      url={url}
      attributeKey={attributeKey}
      colorMap={colorMap}
      dataLayer={dataLayer}
      minzoom={minzoom}
      maxzoom={maxzoom}
      visible={visible}
    />
  );
};
